module.exports = __webpack_public_path__ + "static/sshota0809-81ac1839043a01234308b466e3a23271.jpg";